// import { CiSearch } from 'react-icons/ci';

import { useEffect, useState } from 'react';
import { post } from '../../Auths/AuthToken';
import useFormValidation from '../../../hooks/zodFormValidation';
import appSchema from '../../../schema/appSchema';
import { format, isValid } from 'date-fns';
import AddressBookPopup from '../../AddressBook/AddressBookPopup';
import setUiMessage from '../../../Utilities/Tostify';
import { useDispatch, useSelector } from 'react-redux';
import { handAllReferralDocs } from '../../../redux/slices/referralSlice';
import { Link } from 'react-router-dom';
import { debounce } from 'lodash';
import ReportFormPopup from './ReportFormPopup';
import AttachDocumentsPopup from './AttachDocumentsPopup';
import ConfirmDialog from '../../../Utilities/ConfirmDialog';
import DatePickerCalander from '../../../Utilities/DatePickerCalander';
import { DEFAULT_DATE_FORMATE } from '../../../constents';
// import PatientDocumentPopup from './PatientDocumentPopup';
// import AddEditReferralProviderPopup from './AddEditReferralProviderPopup';

function AddReferralPopup({
  isOpen,
  onClose,
  handleReload,
  refId,
  rptSentId,
  patientId,
  reportId,
}) {
  const dispatch = useDispatch();
  const { allReferralDocs } = useSelector((store) => store.referral);
  const [patientList, setPatientList] = useState([]);
  const [searchStr, setSearchStr] = useState('');
  const [isSubmit, setSubmit] = useState(false);
  const [errMsg, setErrMsg] = useState('');
  const [selectedPat, setSelectedPat] = useState(null);
  const [referredByList, setReferredByList] = useState([]);
  const [addressbook, setAddressbook] = useState(false);
  const [recipiant, setRecipiant] = useState(''); // 2 for provider
  const [formData, setFormData] = useState({
    patientId: 0,
    referralDate: new Date(),
    referredBy: 0,
    urgencyLevel: 'routine',
    referredTo: 0,
    referredToType: '',
    plannedDate: null,
    reasonForReferral: '',
    referralOrder: false,
    referralOrderPdf: '',
    clinicalSummary: false,
    clinicalSummaryPdf: '',
    transitionOfCare: false,
    transitionOfCarePdf: '',
    allAttachDocs: allReferralDocs,
    appointmentScheduled: false,
    patientInformed: false,
    appointmentDate: null,
  });

  const [generateReportPopup, setGenerateReportPopup] = useState({
    open: false,
    popUpType: '',
  });

  const [attachDocPopup, setAttachDocPopup] = useState(false);
  const [selectedDocs, setSelectedDocs] = useState({});

  const [alertPopup, setAlertPopup] = useState(false);
  const [patStatus, setPatStatus] = useState('add');
  const [patObj, setPatObj] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await post('api/patient/referral/openReferralPopup', {
        refId: refId,
        rptSentId: rptSentId,
        patientId: patientId,
        reportId: reportId,
      });

      if (response.status === 200) {
        setReferredByList(response.data?.staff || []);
        if (response.data?.referralData) {
          setFormData((prev) => ({
            ...prev,
            patientId: response.data?.patientId
              ? Number(response.data?.patientId)
              : 0,
            referralDate:
              new Date(response.data?.referralData?.added_date) || new Date(),
            referredBy: response.data?.referralData?.provider_id
              ? Number(response.data?.referralData?.provider_id)
              : 0,
            urgencyLevel:
              response.data?.referralData?.urgency_level || 'routine',
            referredTo: response.data?.recipiantId
              ? Number(response.data?.recipiantId)
              : 0,
            referredToType: response.data?.receiverType || '',
            plannedDate:
              response.data?.referralData?.plan_date &&
              response.data?.referralData?.plan_date !== '0000-00-00'
                ? new Date(response.data?.referralData?.plan_date) || null
                : null,
            reasonForReferral: response.data?.referralData?.reason || '',
            referralOrder: response.data?.reportSentData?.referral_order_file
              ? true
              : false,
            referralOrderPdf:
              response.data?.reportSentData?.referral_order_file || '',
            clinicalSummary: response.data?.reportSentData
              ?.clinical_summary_file
              ? true
              : false,
            clinicalSummaryPdf:
              response.data?.reportSentData?.clinical_summary_file || '',
            transitionOfCare: response.data?.reportSentData?.toc_summary_file
              ? true
              : false,
            transitionOfCarePdf:
              response.data?.reportSentData?.toc_summary_file || '',
            allAttachDocs:
              response.data?.reportSentData?.all_attach_docs &&
              response.data?.reportSentData?.all_attach_docs.length > 0
                ? JSON.parse(response.data?.reportSentData?.all_attach_docs)
                : [],
            appointmentScheduled:
              response.data?.referralData?.appointment_taken === '1'
                ? true
                : false,
            patientInformed:
              response.data?.referralData?.patient_informed === '1'
                ? true
                : false,
            appointmentDate:
              response.data?.referralData?.appointment_taken_date &&
              response.data?.referralData?.appointment_taken_date !==
                '0000-00-00'
                ? new Date(
                    response.data?.referralData?.appointment_taken_date,
                  ) || null
                : null,
          }));
          setSelectedDocs((prev) => {
            let selectedObjs = {};
            const attachDocs =
              response.data?.reportSentData?.all_attach_docs &&
              JSON.parse(response.data?.reportSentData?.all_attach_docs);
            if (attachDocs && attachDocs.length > 0) {
              attachDocs.forEach((doc) => {
                if (
                  doc?.sectionId !== 'patient_referral' &&
                  doc?.sectionId !== 'clinical_summary' &&
                  doc?.sectionId !== 'transition_of_care'
                ) {
                  selectedObjs = { ...selectedObjs, [doc.sectionId]: doc };
                }
              });
            }
            return selectedObjs;
          });
          dispatch(
            handAllReferralDocs(
              JSON.parse(response.data?.reportSentData?.all_attach_docs) || [],
            ),
          );
          setSelectedPat({
            patName: response.data?.patientName || '',
            dob: response.data?.dob || '',
            ageWithGender: response.data?.ageWithGender || '',
            chart_number: response.data?.patientInfo?.chart_number || '',
          });
          setRecipiant(response.data?.receiverName || '');
        }
      }
    };
    fetchData();
  }, [refId, rptSentId, patientId, reportId, dispatch]);

  useEffect(() => {
    if (searchStr === '' || searchStr.length < 3) {
      setPatientList({});
      return;
    }
    const handlePatSearch = async () => {
      const response = await post('api/patient/referral/searchPatient', {
        searchStr: searchStr,
      });

      if (response.status === 200) {
        setPatientList(response.data?.patientList || []);
      }
    };
    //handlePatSearch();

    // Memoize the debounced version so it doesn’t reinitialize on every render
    const debouncedFetch = debounce(handlePatSearch, 500);

    debouncedFetch(searchStr);

    // Cleanup on unmount
    return () => {
      debouncedFetch.cancel();
    };
  }, [searchStr]);

  const { errors, validateForm } = useFormValidation({
    schema: appSchema.addReferralForm(),
    formData: formData,
    isSubmit,
  });

  const handleSaveReferral = async (e, isSend) => {
    e.preventDefault();
    setSubmit(true);

    const validationError = validateForm();
    if (validationError) return;
    try {
      const response = await post('api/patient/referral/saveReferral', {
        formData: {
          ...formData,
          referralDate: format(formData.referralDate, 'yyyy-MM-dd'),
          plannedDate: formData.plannedDate
            ? format(formData.plannedDate, 'yyyy-MM-dd')
            : null,
          appointmentDate: formData.appointmentDate
            ? format(formData.appointmentDate, 'yyyy-MM-dd')
            : null,
          referringProvider: formData.referredBy,
          recipientProvider: formData.referredTo,
          recipientProviderType: formData.referredToType,
          referralOrderDoc: formData.referralOrderPdf,
          clinicalSummaryDoc: formData.clinicalSummaryPdf,
          transitionOfCareDoc: formData.transitionOfCarePdf,
          allAttachDocs: JSON.stringify(allReferralDocs),
          // attachedFiles: allReferralDocs //attachFiles = allAttachDocs.map(el => el.docsName).join(',')
          //   .filter(
          //     (el) =>
          //       el.sectionId !== 'patient_referral' ||
          //       el.sectionId !== 'clinical_summary' ||
          //       el.sectionId !== 'transition_of_care'
          //   )
          //   .map((el) => el.docsName)
          //   .join(','),
          attachedFiles: allReferralDocs.map((el) => el.docsName).join(','),
        },
        sendFax: isSend,
      });

      if (response.status === 200) {
        // Handle success
        handleReload();
        handleCloseReferralPopup();
      }
    } catch (err) {
      setErrMsg(err?.response.data.message);
    }
  };

  const handleDefaultDocsReferralOrder = async (e) => {
    if (!e.target.checked) {
      setFormData((prev) => ({
        ...prev,
        referralOrder: e.target.checked,
      }));
      const updatedDocs = allReferralDocs.filter(
        (obj) => obj.sectionId !== 'patient_referral',
      );
      dispatch(handAllReferralDocs(updatedDocs));
      return;
    }
    if (!formData.patientId) {
      setUiMessage('err', 'Please select patient to add referral order');
      return;
    }
    if (!formData.referredBy) {
      setUiMessage(
        'err',
        'Please select referring provider to add referral order',
      );
      return;
    }
    if (!formData.referredTo) {
      setUiMessage(
        'err',
        'Please select recipient provider to add referral order',
      );
      return;
    }
    // if (formData.reasonForReferral.trim() === '') {
    //   setUiMessage(
    //     'err',
    //     'Please enter reason for referral to add referral order',
    //   );
    //   return;
    // }
    setFormData((prev) => ({
      ...prev,
      referralOrder: e.target.checked,
    }));

    const response = await post(
      'api/patient/referral/patientReferralOrderPdf',
      {
        patientId: formData.patientId,
        referredBy: formData.referredBy,
        referredTo: formData.referredTo,
        referredToType: formData.referredToType,
        reasonForReferral: formData.reasonForReferral,
        referralDate: format(formData.referralDate, 'yyyy-MM-dd'),
      },
    );

    if (response.status === 200) {
      setUiMessage('suc', 'Referral order added successfully');
      let dataObj = JSON.parse(response.data);
      let docObj = {
        sectionId: 'patient_referral',
        docsSection: 'referral order',
        docsTitle: 'Referral Order',
        docsId: '0',
        docsName: dataObj?.file_name,
        docsUrl: dataObj?.file_url,
        docsDate: dataObj?.date,
      };
      setFormData((prev) => ({
        ...prev,
        referralOrderPdf: dataObj?.file_name,
      }));
      dispatch(handAllReferralDocs([...allReferralDocs, docObj]));
    }
  };

  const handleDefaultDocsClinicalSummary = (e) => {
    if (!e.target.checked) {
      setFormData((prev) => ({
        ...prev,
        clinicalSummary: e.target.checked,
      }));
      const updatedDocs = allReferralDocs.filter(
        (obj) => obj.sectionId !== 'clinical_summary',
      );
      dispatch(handAllReferralDocs(updatedDocs));
      return;
    }
    if (e.target.checked && !formData.patientId) {
      setUiMessage('err', 'Please select patient first');
      return;
    }
    setGenerateReportPopup({
      popUpType: 'clinical',
      open: true,
    });
    // setFormData((prev) => ({
    //   ...prev,
    //   clinicalSummary: e.target.checked,
    // }));
  };

  const handleDefaultDocsToc = (e) => {
    if (!e.target.checked) {
      setFormData((prev) => ({
        ...prev,
        transitionOfCare: e.target.checked,
      }));
      const updatedDocs = allReferralDocs.filter(
        (obj) => obj.sectionId !== 'transition_of_care',
      );
      dispatch(handAllReferralDocs(updatedDocs));
      return;
    }
    if (e.target.checked && !formData.patientId) {
      setUiMessage('err', 'Please select patient first');
      return;
    }
    setGenerateReportPopup({
      popUpType: 'toc',
      open: true,
    });
    // setFormData((prev) => ({
    //   ...prev,
    //   transitionOfCare: e.target.checked,
    // }));
  };

  function handleRemoveDocs(index) {
    const docToRemove = allReferralDocs[index]; // store before splicing
    const updatedDocs = allReferralDocs.filter((_, i) => i !== index);

    if (docToRemove?.sectionId === 'patient_referral') {
      setFormData((prev) => ({
        ...prev,
        referralOrder: false,
      }));
    } else if (docToRemove?.sectionId === 'clinical_summary') {
      setFormData((prev) => ({
        ...prev,
        clinicalSummary: false,
      }));
    } else if (docToRemove?.sectionId === 'transition_of_care') {
      setFormData((prev) => ({
        ...prev,
        transitionOfCare: false,
      }));
    }

    dispatch(handAllReferralDocs(updatedDocs));
  }

  const handleCloseReferralPopup = () => {
    onClose();
    dispatch(handAllReferralDocs([]));
  };

  const handlePatientChangeRemove = (obj = null, selPatStatus) => {
    let selectedPatNo = 0;
    if (obj && selPatStatus === 'add') {
      selectedPatNo = Number(obj.user_id);
    }
    if (patObj && selPatStatus === 'change') {
      selectedPatNo = Number(patObj.user_id);
      setSelectedPat(patObj);
    }
    if (selPatStatus === 'remove') setSelectedPat(null);
    dispatch(handAllReferralDocs([]));
    setSelectedDocs({});
    setRecipiant('');
    setFormData((prev) => ({
      ...prev,
      patientId: selectedPatNo,
      referralDate: new Date(),
      referredBy: 0,
      urgencyLevel: 'routine',
      referredTo: 0,
      referredToType: '',
      plannedDate: null,
      reasonForReferral: '',
      referralOrder: false,
      referralOrderPdf: '',
      clinicalSummary: false,
      clinicalSummaryPdf: '',
      transitionOfCare: false,
      transitionOfCarePdf: '',
      allAttachDocs: [],
      appointmentScheduled: false,
      patientInformed: false,
      appointmentDate: null,
    }));
    setPatientList({});
    setSearchStr('');
  };

  return (
    <div className="modalBackground">
      <div className="popup active" id="referralPopup">
        <p className="red" aria-live="assertive">
          {errMsg}
        </p>
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="popup__content p-4 overflow-hidden lg">
            <div className="popup-header mb-5">
              <h2 className="fw-500">New Referral Request</h2>
              <span
                className="close-btn"
                id="closeBtn"
                onClick={handleCloseReferralPopup}
              >
                ×
              </span>
            </div>

            <div className="popup-body border-b-1 border-b-lightgray">
              <div className="tabContainer tabContainer__scrollbar">
                <div className="">
                  <h3 className="fw-500 border-b-1 border-b-lightgray fs-sm pb-4">
                    Patient Face Sheet Documents
                  </h3>
                </div>

                <div className="tabContainer__group flex flex-col flex-1 my-3">
                  <div className="pb-1 fs-xs">
                    Patient Search<span className="text-danger">*</span>
                  </div>
                  <div
                    className={`tabContainer__input-wrapper flex items-center border  rounded-md ${
                      errors?.patientId && errors?.patientId?.message
                        ? 'border-danger'
                        : 'border-lightgray'
                    }`}
                  >
                    <img
                      src="./images/search.svg"
                      width="15"
                      className="ml-2 opacity-50"
                      alt=""
                    />
                    <input
                      type="search"
                      className="tabContainer__input flex-1 fs-xs form-control"
                      placeholder="Search by patient name or chart number..."
                      onChange={(e) => setSearchStr(e.target.value)}
                      value={searchStr}
                    />
                  </div>
                  <div
                    id="patientList"
                    className="tabContainer__group flex flex-col flex-1 my-3"
                  >
                    {patientList.length > 0 ? (
                      patientList.map((obj, idx) => (
                        <div
                          className="usr-name"
                          onClick={() => {
                            if (selectedPat) {
                              // setSelectedPat(obj);
                              setPatStatus('change');
                              setPatObj(obj);
                              setAlertPopup(true);
                            } else {
                              setPatStatus('add');
                              setSelectedPat(obj);
                              handlePatientChangeRemove(obj, 'add');
                            }
                            // dispatch(handAllReferralDocs([]));
                            // setSelectedDocs({});
                            // setRecipiant('');
                            // setFormData((prev) => ({
                            //   ...prev,
                            //   patientId: Number(obj.user_id),
                            //   referralDate: new Date(),
                            //   referredBy: 0,
                            //   urgencyLevel: 'routine',
                            //   referredTo: 0,
                            //   referredToType: '',
                            //   plannedDate: null,
                            //   reasonForReferral: '',
                            //   referralOrder: false,
                            //   referralOrderPdf: '',
                            //   clinicalSummary: false,
                            //   clinicalSummaryPdf: '',
                            //   transitionOfCare: false,
                            //   transitionOfCarePdf: '',
                            //   allAttachDocs: [],
                            //   appointmentScheduled: false,
                            //   patientInformed: false,
                            //   appointmentDate: null,
                            // }));
                            // setPatientList({});
                            // setSearchStr('');
                            // setSelectedPat(obj);
                          }}
                          key={obj.user_id}
                        >
                          <span className="name">{obj.patName}</span>
                          <span className="msg-bx-sep">|</span>
                          <span className="name">DOB: {obj.dob}</span>
                          <span className="msg-bx-sep">|</span>
                          <span className="name">{obj.ageWithGender}</span>
                          <span className="msg-bx-sep">|</span>
                          <span className="name">
                            Chart ID: {obj.chart_number}
                          </span>
                        </div>
                      ))
                    ) : (
                      <>
                        {isSubmit &&
                          errors?.patientId &&
                          errors?.patientId?.message && (
                            <div className="red">
                              Please select patient from the list
                            </div>
                          )}
                      </>
                    )}
                  </div>
                </div>
                {/* show data after search */}
                <div className="tabContainer__list mb-3">
                  {formData?.patientId !== 0 && (
                    <div className="tabContainer__item p-2 border border-lightgray bg-light fs-xs rounded-md cursor-pointer space-between items-center">
                      <div className="tabContainer__info flex justify-between">
                        <span className="text-dark fs-xs">
                          {`${selectedPat?.patName} | ${selectedPat?.dob} | ${selectedPat?.ageWithGender} | Chart ID: ${selectedPat?.chart_number}`}
                        </span>
                        <span
                          className="text-dark fs-xs"
                          onClick={() => {
                            if (selectedPat) {
                              setPatStatus('remove');
                              setPatObj(null);
                              setAlertPopup(true);
                            }
                            // dispatch(handAllReferralDocs([]));
                            // setSelectedDocs({});
                            // setRecipiant('');
                            // setFormData((prev) => ({
                            //   ...prev,
                            //   patientId: 0,
                            //   referralDate: new Date(),
                            //   referredBy: 0,
                            //   urgencyLevel: 'routine',
                            //   referredTo: 0,
                            //   referredToType: '',
                            //   plannedDate: null,
                            //   reasonForReferral: '',
                            //   referralOrder: false,
                            //   referralOrderPdf: '',
                            //   clinicalSummary: false,
                            //   clinicalSummaryPdf: '',
                            //   transitionOfCare: false,
                            //   transitionOfCarePdf: '',
                            //   allAttachDocs: [],
                            //   appointmentScheduled: false,
                            //   patientInformed: false,
                            //   appointmentDate: null,
                            // }));
                          }}
                        >
                          X
                        </span>
                      </div>
                    </div>
                  )}
                </div>
                <div className="tabContainer__group flex flex-col flex-1 mb-3">
                  <label className="pb-1 fs-sm">
                    Referral Date <span className="text-danger">*</span>
                  </label>
                  <div className="tabContainer__input-wrapper flex items-center border border-lightgray rounded-md referral-date-picker">
                    <img
                      src="./images/calender.svg"
                      width={18}
                      className="ml-2 opacity-50"
                      alt="Calendar"
                    />
                    <DatePickerCalander
                      selectedDate={formData.referralDate}
                      setSelectedDate={(date) => {
                        if (!isValid(date)) return;
                        setFormData((prev) => ({
                          ...prev,
                          referralDate: date,
                        }));
                      }}
                      className="width100"
                      dateFormat={DEFAULT_DATE_FORMATE}
                      // minDate={startDate}
                      editFlag={false}
                      containerDivStyle={{ width: '100%' }}
                    />
                    {/* <input
                      type="date"
                      className={`tabContainer__input flex-1 fs-xs form-control ${
                        errors?.patientId && errors?.patientId?.message
                          ? 'border-danger'
                          : 'border-lightgray'
                      }`}
                      placeholder=""
                      value={format(formData.referralDate, 'yyyy-MM-dd')}
                      onChange={(e) => {
                        if (!isValid(new Date(e.target.value))) return;
                        setFormData((prev) => ({
                          ...prev,
                          referralDate: new Date(e.target.value),
                        }));
                      }}
                    /> */}
                  </div>
                </div>
                <div className="tabContainer__row flex gap-4 flex-wrap mb-3">
                  <div className="tabContainer__group flex flex-col flex-1">
                    <label className="pb-1 fs-xs">
                      Referring Provider <span className="text-danger">*</span>
                    </label>
                    <select
                      className={`form-control bg-white ${
                        errors?.referredBy && errors?.referredBy?.message
                          ? 'border-danger'
                          : ''
                      }`}
                      id="referredBy"
                      value={Number(formData.referredBy)}
                      onChange={(e) => {
                        setFormData((prev) => {
                          return {
                            ...prev,
                            referredBy: Number(e.target.value),
                          };
                        });
                      }}
                    >
                      <option value={0}>Select reffering provider</option>
                      {referredByList.length > 0 &&
                        referredByList.map((obj, idx) => (
                          <option key={obj.id} value={Number(obj.id)}>
                            {obj.name}
                          </option>
                        ))}
                    </select>
                    <div className="red my-3">
                      {errors?.referredBy && errors?.referredBy?.message}
                    </div>
                  </div>
                  <div className="tabContainer__group flex flex-col flex-1">
                    <label className="pb-1 fs-xs">
                      Urgency Level<span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control bg-white"
                      value={formData.urgencyLevel}
                      onChange={(e) => {
                        setFormData((prev) => {
                          return {
                            ...prev,
                            urgencyLevel: e.target.value,
                          };
                        });
                      }}
                    >
                      <option value="routine">Routine</option>
                      <option value="urgent">Urgent</option>
                      <option value="asap">ASAP</option>
                    </select>
                  </div>
                  <div className="red my-3">
                    {errors?.urgencyLevel && errors?.urgencyLevel?.message}
                  </div>
                </div>
                <div className="">
                  <h3 className="fw-500 border-b-1 border-b-lightgray fs-sm pt-4 pb-3">
                    Referral Details
                  </h3>
                </div>
                <div className="tabContainer__row flex gap-4 flex-wrap my-3">
                  <div className="tabContainer__list flex flex-col flex-1">
                    <span className="fs-xs pb-2">
                      Recipient Provider/Clinic
                      <span className="text-danger">*</span>
                    </span>
                    <label className="tabContainer__item flex items-center gap-2 p-2 bg-light border border-lightgray fs-xs rounded-md cursor-pointer">
                      <div
                        className="tabContainer__info flex items-center gap-1"
                        onClick={() => setAddressbook(true)}
                      >
                        <img
                          src="./images/padnote-black.svg"
                          width={16}
                          className="opacity-50"
                          alt="Recipient"
                        />
                        <span className="fs-xs text-dark">
                          {recipiant || 'Select Recipient'}
                        </span>
                      </div>
                    </label>
                    <div className="red my-3">
                      {errors?.referredTo && errors?.referredTo?.message}
                    </div>
                  </div>
                  <div className="tabContainer__group flex flex-col flex-1">
                    <label className="pb-1 fs-xs">Planned Date</label>
                    <div className="tabContainer__input-wrapper flex items-center border border-lightgray rounded-md referral-date-picker">
                      <img
                        src="./images/calender.svg"
                        width={18}
                        className="ml-2 opacity-50"
                        alt="Calendar"
                      />
                      {/* <input
                        type="date"
                        className="tabContainer__input flex-1 fs-xs form-control"
                        placeholder="Select date"
                        value={
                          formData.plannedDate
                            ? format(formData.plannedDate, 'yyyy-MM-dd')
                            : ''
                        }
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            plannedDate: e.target.value
                              ? new Date(e.target.value)
                              : null,
                          }));
                        }}
                      /> */}
                      <DatePickerCalander
                        selectedDate={
                          formData.plannedDate ? formData.plannedDate : null
                        }
                        setSelectedDate={(date) => {
                          if (!isValid(date)) return;
                          setFormData((prev) => ({
                            ...prev,
                            plannedDate: date ? date : null,
                          }));
                        }}
                        className="width100"
                        dateFormat={DEFAULT_DATE_FORMATE}
                        // minDate={startDate}
                        editFlag={false}
                        containerDivStyle={{ width: '100%' }}
                      />
                    </div>
                  </div>
                </div>
                <div className="tabContainer__group flex flex-col flex-1 mb-3">
                  <label className="pb-1 fs-xs">
                    Reason for Referral<span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows={6}
                    cols={6}
                    placeholder=""
                    value={formData.reasonForReferral}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        reasonForReferral: e.target.value,
                      }))
                    }
                  />
                  <div className="red my-3">
                    {errors?.reasonForReferral &&
                      errors?.reasonForReferral?.message}
                  </div>
                </div>
                {/* Documents */}
                <div className="mb-4">
                  <h3 className="fw-500 border-b-1 border-b-lightgray fs-sm py-3 mb-3">
                    Documents
                  </h3>
                  <p className="fw-500 text-dark">Default Documents</p>
                  <p></p>
                </div>
                <div className="tabContainer__row flex gap-4 flex-wrap mb-3">
                  <div className="tabContainer__list flex flex-col flex-1">
                    <label className="tabContainer__item flex items-center gap-2 p-2 bg-light border border-lightgray fs-xs rounded-md cursor-pointer">
                      <input
                        type="checkbox"
                        checked={formData.referralOrder}
                        value={formData.referralOrder}
                        onChange={handleDefaultDocsReferralOrder}
                        name="referralOrder"
                      />
                      <div className="tabContainer__info">
                        <span className="fs-xs text-dark">Referral Order</span>
                      </div>
                    </label>
                  </div>
                  <div className="tabContainer__list flex flex-col flex-1">
                    <label className="tabContainer__item flex items-center gap-2 p-2 bg-light border border-lightgray fs-xs rounded-md cursor-pointer">
                      <input
                        type="checkbox"
                        checked={
                          formData.clinicalSummary &&
                          formData.clinicalSummaryPdf
                        }
                        value={formData.clinicalSummary}
                        onChange={handleDefaultDocsClinicalSummary}
                        name="clinicalSummary"
                        disabled={formData.transitionOfCare ? true : false}
                      />
                      <div className="tabContainer__info">
                        <span className="fs-xs text-dark">
                          Clinical Summary
                        </span>
                      </div>
                    </label>
                  </div>
                  <div className="tabContainer__list flex flex-col flex-1">
                    <label className="tabContainer__item flex items-center gap-2 p-2 bg-light border border-lightgray fs-xs rounded-md cursor-pointer">
                      <input
                        type="checkbox"
                        checked={
                          formData.transitionOfCare &&
                          formData.transitionOfCarePdf
                        }
                        value={formData.transitionOfCare}
                        onChange={handleDefaultDocsToc}
                        name="transitionOfCare"
                        disabled={formData.clinicalSummary ? true : false}
                      />
                      <div className="tabContainer__info">
                        <span className="fs-xs text-dark">
                          Transition of Care
                        </span>
                      </div>
                    </label>
                  </div>
                </div>
                <div className="tabContainer__row flex justify-between items-center pt-2 mb-3">
                  <p className="text-dark">Patient Chart Documents</p>
                  <span
                    className="text-dark border border-lightgray py-2 px-3 rounded-md flex items-center gap-2 cursor-pointer"
                    onClick={() => {
                      if (formData.patientId) setAttachDocPopup(true);
                      else setUiMessage('err', 'Please select patient first');
                    }}
                  >
                    <img
                      src="./images/upload.svg"
                      width={15}
                      className="opacity-70"
                      alt=""
                    />
                    Select from patient chart
                  </span>
                </div>
                {allReferralDocs.length === 0 ? (
                  <div className="tabContainer__group flex flex-col gap-3 items-center mb-3 p-5 border-2 border-dashed border-lightgray rounded-sm">
                    <img src="./images/file-alt.svg" width={55} alt="" />
                    <span className="fs-sm text-gray">
                      No documents from patient chart
                    </span>
                    <p className="fs-xs text-gray">
                      Click "Select from Patient Chart" to attach documents
                    </p>
                  </div>
                ) : (
                  <div className="tabContainer__group flex flex-col gap-3 mb-3 p-5 border-2 border-dashed border-lightgray rounded-sm">
                    <div className="tabContainer__list flex flex-col gap-3">
                      {allReferralDocs.map((obj, idx) => (
                        <div
                          key={obj.sectionId}
                          className="tabContainer__item flex items-center gap-2 p-2 border border-lightgray fs-xs rounded-md cursor-pointer"
                          id={`attchedLevel_${obj.sectionId}`}
                        >
                          <div className="tabContainer__icon lightblue flex items-center justify-center rounded-md">
                            <img
                              src="./images/user-blue.svg"
                              width={15}
                              alt=""
                            />
                          </div>
                          <div className="tabContainer__info flex flex-col">
                            <span className="">
                              <Link to={obj.docsUrl} target="_blank">
                                {obj.docsTitle}
                              </Link>
                            </span>
                            <span className="fs-xxs text-gray">
                              {obj.docsDate}
                            </span>
                          </div>
                          <img
                            src="./images/delete.svg"
                            className="ml-auto"
                            width={15}
                            alt="Delete"
                            onClick={() => handleRemoveDocs(idx)}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* <div className="tabContainer__list flex flex-col gap-3">
                  <label className="tabContainer__item flex items-center gap-2 p-2 border border-lightgray fs-xs rounded-md cursor-pointer">
                    <div className="tabContainer__icon lightblue flex items-center justify-center rounded-md">
                      <img src="./images/user-blue.svg" width={15} alt="" />
                    </div>
                    <div className="tabContainer__info flex flex-col">
                      <span className="">Referral Order</span>
                      <span className="fs-xxs text-gray">2024-01-15</span>
                    </div>
                    <img
                      src="./images/delete.svg"
                      className="ml-auto"
                      width={15}
                      alt="Delete"
                    />
                  </label>
                  <label className="tabContainer__item flex items-center gap-2 p-2 border border-lightgray fs-xs rounded-md cursor-pointer">
                    <div className="tabContainer__icon lightblue flex items-center justify-center rounded-md">
                      <img src="./images/user-blue.svg" width={15} alt="" />
                    </div>
                    <div className="tabContainer__info flex flex-col">
                      <span className="">
                        Patient Demographics &amp; Contact Information
                      </span>
                      <span className="fs-xxs text-gray">2024-01-15</span>
                    </div>
                    <img
                      src="./images/delete.svg"
                      className="ml-auto"
                      width={15}
                      alt=""
                    />
                  </label>
                </div> */}
                {/* Status & Follow-up */}
                <div className="mb-4">
                  <h3 className="fw-500 border-b-1 border-b-lightgray fs-sm py-3 mb-3">
                    Status &amp; Follow-up
                  </h3>
                </div>
                <div className="tabContainer__row flex items-center gap-4 flex-wrap mb-3">
                  <div className="flex flex-col gap-3 flex-1">
                    <div className="tabContainer__list">
                      <label className="tabContainer__item flex items-center justify-between gap-2 p-2 bg-light border border-lightgray fs-xs rounded-md cursor-pointer">
                        <div className="tabContainer__info">
                          <span className="fs-xs text-dark">
                            Appointment Scheduled
                          </span>
                        </div>
                        <input
                          type="checkbox"
                          value={formData.appointmentScheduled}
                          checked={formData.appointmentScheduled}
                          onChange={() =>
                            setFormData((prev) => ({
                              ...prev,
                              appointmentScheduled:
                                !formData.appointmentScheduled,
                            }))
                          }
                        />
                      </label>
                    </div>
                    <div className="tabContainer__list">
                      <label className="tabContainer__item flex items-center justify-between gap-2 p-2 bg-light border border-lightgray fs-xs rounded-md cursor-pointer">
                        <div className="tabContainer__info">
                          <span className="fs-xs text-dark">
                            Patient Informed
                          </span>
                        </div>
                        <input
                          type="checkbox"
                          value={formData.patientInformed}
                          checked={formData.patientInformed}
                          onChange={() =>
                            setFormData((prev) => ({
                              ...prev,
                              patientInformed: !formData.patientInformed,
                            }))
                          }
                        />
                      </label>
                    </div>
                  </div>
                  <div className="tabContainer__group flex flex-col flex-1 mb-3">
                    <label className="pb-1 fs-xs">Appointment Date</label>
                    <div className="tabContainer__input-wrapper flex items-center border border-lightgray rounded-md referral-date-picker">
                      <img
                        src="./images/calender.svg"
                        width={18}
                        className="ml-2 opacity-50"
                        alt=""
                      />
                      {/* <input
                        type="date"
                        className="tabContainer__input flex-1 fs-xs form-control"
                        placeholder="Select date"
                        value={
                          formData.appointmentDate
                            ? format(formData.appointmentDate, 'yyyy-MM-dd')
                            : ''
                        }
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            appointmentDate: e.target.value
                              ? new Date(e.target.value)
                              : null,
                          }))
                        }
                      /> */}
                      <DatePickerCalander
                        selectedDate={
                          formData.appointmentDate
                            ? formData.appointmentDate
                            : null
                        }
                        setSelectedDate={(date) => {
                          if (!isValid(date)) return;
                          setFormData((prev) => ({
                            ...prev,
                            appointmentDate: date ? date : null,
                          }));
                        }}
                        className="width100"
                        dateFormat={DEFAULT_DATE_FORMATE}
                        editFlag={false}
                        containerDivStyle={{ width: '100%' }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="popup-footer flex justify-end items-center gap-4 p-4">
              <button
                type="button"
                className="btn-outline-gray rounded-md"
                onClick={handleCloseReferralPopup}
              >
                Cancel
              </button>
              {refId ? (
                <>
                  <button
                    type="button"
                    className="btn-outline-gray rounded-md"
                    onClick={(e) => handleSaveReferral(e, false)}
                  >
                    Update Referral
                  </button>
                  <button
                    type="button"
                    className="btn-primary rounded-md"
                    onClick={(e) => handleSaveReferral(e, true)}
                  >
                    Update &amp; Fax Referral
                  </button>
                </>
              ) : (
                <>
                  <button
                    type="button"
                    className="btn-outline-gray rounded-md"
                    onClick={(e) => handleSaveReferral(e, false)}
                  >
                    Save Referral
                  </button>
                  <button
                    type="button"
                    className="btn-primary rounded-md"
                    onClick={(e) => handleSaveReferral(e, true)}
                  >
                    Save &amp; Fax Referral
                  </button>
                </>
              )}
            </div>
          </div>
        </form>
      </div>
      {addressbook && (
        <AddressBookPopup
          onClose={() => setAddressbook(false)}
          type={2}
          onSelectAddress={(address, type) => {
            setRecipiant(address.nameLabel);
            setFormData((prev) => ({
              ...prev,
              referredTo: Number(address.id),
              referredToType: type,
            }));
            setAddressbook(false);
          }}
        />
      )}
      {/* {editPopup.open && (
        <AddEditReferralProviderPopup
          onClose={() => setEditPopup({ open: false, referringMasterId: '' })}
          onReload={onReload}
          editPopup={editPopup}
          setEditPopup={setEditPopup}
        />
      )} */}
      {formData?.patientId && generateReportPopup.open && (
        <ReportFormPopup
          onClose={() =>
            setGenerateReportPopup({ ...generateReportPopup, open: false })
          }
          patId={formData?.patientId}
          selectedPat={selectedPat}
          popUpType={generateReportPopup.popUpType}
          selectPurposeOption={(opt) =>
            setGenerateReportPopup({ ...generateReportPopup, popUpType: opt })
          }
          setFormData={setFormData}
        />
      )}
      {formData?.patientId && attachDocPopup && (
        <AttachDocumentsPopup
          patientId={formData?.patientId}
          selectedDocs={selectedDocs}
          setSelectedDocs={setSelectedDocs}
          closePopup={() => setAttachDocPopup(false)}
        />
      )}
      {alertPopup && (
        <ConfirmDialog
          title={`Confirmation`}
          bodytext={`Are you sure you want to remove/change this patient? All details added will be removed.`}
          closeDialog={() => {
            setPatObj(null);
            setAlertPopup(false);
          }}
          successDialog={() => handlePatientChangeRemove(null, patStatus)}
        />
      )}
    </div>
  );
}

export default AddReferralPopup;
